<template>
    <div class="col-sm-12 list-content-item mb-2">
        <div class="row">
            <div class="col-auto image-container">
                <avatar-badge :src="displayImage" :raised="false" :size="100"></avatar-badge>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-lg-9">
                        <h2 class="title mt-2" v-text="expert.fullname"></h2>
                    </div>
                </div>
                <div class="description mb-2" v-text="expert.email"></div>
                <!-- <div v-if="expert.mobile_no" class="description">{{ expert.mobile_no }} (Mobile)</div>
                <div v-else class="description text-muted">No mobile no. provided</div> -->
                <div class="description">
                    <span class="text-muted mr-2">Expertise:</span>
                    <span class="font-weight-500" v-text="displayedExpertise"></span>
                </div>
                <div class="text-right">
                    <!-- <router-link :to="link" v-slot="{ href, navigate }">
                        <a :href="href" @click="navigate" class="btn btn-sm btn-warning">
                            <i class="fa fa-eye mr-1"></i> View Details
                        </a>
                    </router-link> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mixins from "@utils/mixins";
import { route, destroy, resource } from "@utils/network";
export default {
    name: "ExpertListItem",

    computed: {
        displayImage() {
            return this.expert.display_image || resource("images/placeholders/avatar.jpg");
        },
        displayedAddress() {
            return this.expert.address ? this.expert.address.display_name : "";
        },
        displayedExpertise() {
            const expertise = this.expert.expertise || [];

            return expertise.map(experty => experty.name).join(", ");
        },
    },

    mixins: [mixins],
    
    props: {
        expert: [Object],
    },

    mounted() {

    }
}
</script>